/** @format */

const emailProviders = require("../../data/emailProviders");
const remoteConfig = require("./remote");

module.exports = {
  partnerId: "aspire",
  partnerName: "AspireGlobal",
  country: null,
  fallbackCountry: "GB",
  restrictedCountries: [],
  featuredCountries: [],
  supportedCountries: [
    "AF",
    "AX",
    "AL",
    "DZ",
    "AS",
    "AD",
    "AO",
    "AI",
    "AR",
    "AM",
    "AW",
    "AU",
    "AT",
    "AZ",
    "BS",
    "BE",
    "BH",
    "BD",
    "BB",
    "BY",
    "BZ",
    "BJ",
    "BM",
    "BT",
    "BO",
    "BQ",
    "BA",
    "BW",
    "BR",
    "AQ",
    "IO",
    "VG",
    "BN",
    "BG",
    "BF",
    "BI",
    "KH",
    "CM",
    "CA",
    "CV",
    "KY",
    "CF",
    "TD",
    "CL",
    "CN",
    "CX",
    "CC",
    "CO",
    "KM",
    "CG",
    "CK",
    "CR",
    "HR",
    "CU",
    "CW",
    "CY",
    "CZ",
    "CD",
    "DK",
    "DJ",
    "DM",
    "DO",
    "TL",
    "EC",
    "EG",
    "SV",
    "GQ",
    "ER",
    "EE",
    "ET",
    "FK",
    "FO",
    "FJ",
    "FI",
    "FR",
    "GF",
    "PF",
    "TF",
    "GA",
    "GM",
    "GE",
    "DE",
    "GH",
    "GI",
    "GR",
    "GL",
    "GD",
    "GP",
    "GU",
    "GT",
    "GG",
    "GN",
    "GW",
    "GY",
    "HT",
    "HM",
    "HN",
    "HK",
    "HU",
    "IS",
    "IN",
    "ID",
    "IR",
    "IQ",
    "IE",
    "IM",
    "IL",
    "IT",
    "CI",
    "JM",
    "JP",
    "JE",
    "JO",
    "KZ",
    "KE",
    "KI",
    "XK",
    "KW",
    "KG",
    "LA",
    "LV",
    "LB",
    "LS",
    "LR",
    "LY",
    "LI",
    "LT",
    "LU",
    "MO",
    "MK",
    "MG",
    "MW",
    "MY",
    "MV",
    "ML",
    "MT",
    "MH",
    "MQ",
    "MR",
    "MU",
    "YT",
    "MX",
    "FM",
    "MD",
    "MC",
    "MN",
    "ME",
    "MS",
    "MA",
    "MZ",
    "MM",
    "NA",
    "NR",
    "NP",
    "NL",
    "NC",
    "NZ",
    "NI",
    "NE",
    "NG",
    "NU",
    "NF",
    "KP",
    "MP",
    "NO",
    "OM",
    "PK",
    "PW",
    "PS",
    "PA",
    "PG",
    "PY",
    "PE",
    "PH",
    "PN",
    "PL",
    "PT",
    "PR",
    "QA",
    "RE",
    "RO",
    "RU",
    "RW",
    "BL",
    "SH",
    "KN",
    "LC",
    "MF",
    "PM",
    "VC",
    "WS",
    "SM",
    "ST",
    "SA",
    "SN",
    "RS",
    "SC",
    "SL",
    "SG",
    "SX",
    "SK",
    "SI",
    "SB",
    "SO",
    "ZA",
    "GS",
    "KR",
    "ES",
    "LK",
    "SD",
    "SR",
    "SJ",
    "SZ",
    "SE",
    "CH",
    "SY",
    "TW",
    "TJ",
    "TZ",
    "TH",
    "TG",
    "TK",
    "TO",
    "TT",
    "TN",
    "TR",
    "TM",
    "TC",
    "TV",
    "VI",
    "UG",
    "UA",
    "AE",
    "GB",
    "US",
    "UY",
    "UZ",
    "VU",
    "VA",
    "VE",
    "VN",
    "WF",
    "YE",
    "ZM",
    "ZW",
  ],
  languages: [
    "en",
    "sv",
    "de",
    "fi",
    "no",
    "po",
    "ja",
    "nl",
    "fr",
    "es",
    "it",
    "da",
    "tr",
    "escl",
  ],
  oneInputAddressCountries: [
    "AE",
    "VN",
    "RO",
    "IN",
    "CN",
    "MT",
    "IE",
    "RU",
    "UA",
    "ES",
    "DK",
  ],
  postalCodeOLA: {
    enabled: false,
  },
  allowedCountriesForReverseLookup: [
    // List of countries that are allowed to perform reverse lookup for postal code and province on house number screen
    "US",
    "DE",
    "SE",
    "GB",
    "NO",
    "FI",
    "DK",
    "SG",
    "CA",
    "RU",
    "UA",
    "TR",
    "ID",
    "MY",
    "KZ",
    "IL",
  ],
  showSpainFiscalRegion: true, // Accepts a Boolean, to show or hide Fiscal region screen for Spanish flow.
  ibanCountries: [], // List of IBAN countries to check
  language: null,
  selectableCurrencies: ["eur", "usd", "gbp"], // ['currency'] - not releated by countries, [{id:'usd', countries: ['ca']}] - related to countries
  fallbackLanguage: "en-GB",
  hidePasswordByDefault: ["desktop"], // accept ['mobile','desktop'] or false
  loginRedirectURL: "",
  loginRedirectOnOverview: true,
  loginRedirectEmitEvent: true, // emit event callback when clicking on login redirect URL
  forceMobileOTPDeliveryMethod: "MOBILE", // Accepts a String OR an Object | String (apply to all countries) - accepts MOBILE=sms or DISPLAY=flash-sms, if nothing is set, it'll fallback to global api settings | Object (apply to specific countries) - accepts Country code and Otp delivery type - {C1 : 'MOBILE', C2: 'DISPLAY' }
  defaultGeoIPService: "regily",
  usernameRules: {
    allowedCharactersReg: /^[a-zA-Z0-9.@_-]+$/i,
  },
  passwordRules: {
    allowedCharactersReg: /^[a-zA-Z0-9.@_-]+$/i,
    minLength: 8,
    maxLength: 16,
    letters: false,
    letterCasing: false,
    digits: false,
    specials: false,
    mustNotInclude: false,
    digitsOrSpecials: false, // if we want either digits or specials and not both
    restrictedProperties: ["username"], // [Takes effect if "password-warning" screen is present only]. Properties to restrict from the password, accepts ['email', 'name', 'username','birthdate'], if nothing is set, it defaults to ALL.
    customConfig: {
      mode: null,
      criteria: ["lowercase", "uppercase", "digit", "special"],
      minimumMatchingCriteria: 2, // minimum criteria that the password must match
      validateEmail: false,
    },
  },
  fullNameRegExp: /[^a-zA-Zａ-ｚＡ-ＺÆÐƎƏƐƔĲŊŒẞÞǷȜæðǝəɛɣĳŋœĸſßþƿȝĄƁÇĐƊĘĦĮƘŁØƠŞȘŢȚŦŲƯY̨Ƴąɓçđɗęħįƙłøơşșţțŧųưy̨ƴÁÀÂÄǍĂĀÃÅǺĄÆǼǢƁĆĊĈČÇĎḌĐƊÐÉÈĖÊËĚĔĒĘẸƎƏƐĠĜǦĞĢƔáàâäǎăāãåǻąæǽǣɓćċĉčçďḍđɗðéèėêëěĕēęẹǝəɛġĝǧğģɣĤḤĦIÍÌİÎÏǏĬĪĨĮỊĲĴĶƘĹĻŁĽĿʼNŃN̈ŇÑŅŊÓÒÔÖǑŎŌÕŐỌØǾƠŒĥḥħıíìiîïǐĭīĩįịĳĵķƙĸĺļłľŀŉńn̈ňñņŋóòôöǒŏōõőọøǿơœŔŘŖŚŜŠŞȘṢẞŤŢṬŦÞÚÙÛÜǓŬŪŨŰŮŲỤƯẂẀŴẄǷÝỲŶŸȲỸƳŹŻŽẒŕřŗſśŝšşșṣßťţṭŧþúùûüǔŭūũűůųụưẃẁŵẅƿýỳŷÿȳỹƴźżžẓ\u{3040}-\u{30ff}\u{3400}-\u{4dbf}\u{4e00}-\u{9fff}\u{f900}-\u{faff}\u{ff66}-\u{ff9f}\u{0400}-\u{04FF}\s]/gu,
  animateOverview: false,
  animateSelectors: true,
  minimumBirthAge: { default: 18, CA: 19 }, // {default: 18} - default value of minimum birth age. {COUNTRY: VALUE} - for specific country value
  allowBackFromFirstScreen: false,
  mobileCountryPrefixSettings: {
    // options: [],
    mode: "all",
    /**
     * Above accepts values:
     *  - 'all' [default and fallback]: Country and Mobile number can be from different countries, and all prefixes are allowed
     *  - 'one': Country and Mobile number have to be from the same country, and no prefix edit option
     *  - 'restrict': restrict the countries in the options property from the prefixes list
     *  - 'allow': allow only the countries in the options property to be shown in the prefixes list
     */
  },
  allowFourDigitYear: true,
  waitForCallback: [],
  bonusesOnLastStep: "all", // Array of countries to add bonus-selector to the last step
  hideBonuses: {}, // Not show bonus selector for {country: ['state']}
  socialMedia: {
    enabled: false,
    allowOnlyLoggedIn: false, // Allow only user who are already logged in to a service; Support: Facebook only
    facebookAppId: "1940626266248961",
    googleId:
      "485912056311-pdk2vl5uis0a7cvp4ep5p6f7fuuffkl2.apps.googleusercontent.com",
    linkedInId: "7803pkog06nlor",
  },
  googleAutocompleteKey: "AIzaSyBrCAzXUH_wzRJEmQw9StDs2aD7GTNWsvc", // set this to 'AIzaSyBrCAzXUH_wzRJEmQw9StDs2aD7GTNWsvc' or another google places API key to enable places autocomplete or false to disable
  showRegilyBadge: false,
  dataTransformSchema: "aspire",
  recaptcha: {
    enabled: false,
    options: {
      // https://developers.google.com/recaptcha/docs/display#explicit_render
      // Supported in config: sitekey, theme, size, tabindex
      sitekey: "6Lf9sGMUAAAAAMLxZbaNoh0JhK7vKAkXP6R0Q-Pl",
    },
  },
  sanctionsLookup: {
    enabled: false,
    useCustomLookup: false, // Use the new sanctions lookup instead of opensanctions provider
    defaultBackendService: "sanctions",
  },
  sentry: {
    dsn:
      "https://ef870fec1654446d86f91847852203c1@o266176.ingest.sentry.io/5428203",
  },
  enableRegilyAnalyzer: false,
  allowDataLookup: true,
  useDynamicCopy: false,
  useDynamicCopyFromOwnSubDomain: false,
  allowIncorrectEmail: true, // true to show the "it's correct" button on email validation
  externalLinks: {
    enabled: true, // used to prevent issues on gradual release
    partnerModal: true,
  },
  regulation: {
    enabled: false,
    countries: ["GB"],
  },
  remoteConfig,
  alertBar: {
    enabled: true,
    countries: ["GB"], // Accepts boolean or an array list of allowed countries
    openLinkInExternal: true, // true to open links in new tab
    enableCollapsing: true, // allow to toggle alert content
  },
  noDataPersistenceCountries: [], // to disable prefilling inputs (credentials, user...etc) based on previously entered values stored in the sessionStorage
  noPersonalDataLookupCountries: [], // to disabled the address, name & gender lookup/prefilling
  noSpecificContentCountries: [], // to hide the hint for the phone number, country selection on the postal code screen, disable don't remember flow, disable phone validation and disable postal code masking
  blockPostalCodes: false, // can also be set in customData by value `blockPostalCodes`
  // if we want to block other than postal codes in blockedPostals.js we can add `blockedPostalCodes` to custom data, and this will overwrite default postal codes
  hideSHProvince: false, // can also be set in customData by value `hideSHProvince`
  enableEmailSuggestion: false,
  suggestionsProvider: {
    enabled: true,
    providers: emailProviders,
  },
  tooltip: {
    enabled: false,
  },
  otpProvider: {
    default: [], // set which provider to use by country for each sending attempt, each item in the array represent which provider to use for the corresponding attempt, e.i: ['attemp1' => otp1,'attemp2' => otp2....]
  },
  findClosestStreet: false,
  emailPath: "/chapter1/email",
  loginRedirectURLRemote: "https://www.aspire.com/",
  noCountrySelectorCountries: "all", // list of countries where "country selector" should be disabled. Accepts array or ALL
  enableOTP: true, // Accepts boolean, true to get the FLOW with OTP
  customRegex: {
    maidenNameRegExp: /[a-zA-Z\-ÆÐƎƏƐƔĲŊŒẞÞǷȜæðǝəɛɣĳŋœĸſßþƿȝĄƁÇĐƊĘĦĮƘŁØƠŞȘŢȚŦŲƯY̨Ƴąɓçđɗęħįƙłøơşșţțŧųưy̨ƴÁÀÂÄǍĂĀÃÅǺĄÆǼǢƁĆĊĈČÇĎḌĐƊÐÉÈĖÊËĚĔĒĘẸƎƏƐĠĜǦĞĢƔáàâäǎăāãåǻąæǽǣɓćċĉčçďḍđɗðéèėêëěĕēęẹǝəɛġĝǧğģɣĤḤĦIÍÌİÎÏǏĬĪĨĮỊĲĴĶƘĹĻŁĽĿʼNŃN̈ŇÑŅŊÓÒÔÖǑŎŌÕŐỌØǾƠŒĥḥħıíìiîïǐĭīĩįịĳĵķƙĸĺļłľŀŉńn̈ňñņŋóòôöǒŏōõőọøǿơœŔŘŖŚŜŠŞȘṢẞŤŢṬŦÞÚÙÛÜǓŬŪŨŰŮŲỤƯẂẀŴẄǷÝỲŶŸȲỸƳŹŻŽẒŕřŗſśŝšşșṣßťţṭŧþúùûüǔŭūũűůųụưẃẁŵẅƿýỳŷÿȳỹƴźżžẓ]+$/g,
    placeOfBirthRegexExp: /[a-zA-Z\-ÆÐƎƏƐƔĲŊŒẞÞǷȜæðǝəɛɣĳŋœĸſßþƿȝĄƁÇĐƊĘĦĮƘŁØƠŞȘŢȚŦŲƯY̨Ƴąɓçđɗęħįƙłøơşșţțŧųưy̨ƴÁÀÂÄǍĂĀÃÅǺĄÆǼǢƁĆĊĈČÇĎḌĐƊÐÉÈĖÊËĚĔĒĘẸƎƏƐĠĜǦĞĢƔáàâäǎăāãåǻąæǽǣɓćċĉčçďḍđɗðéèėêëěĕēęẹǝəɛġĝǧğģɣĤḤĦIÍÌİÎÏǏĬĪĨĮỊĲĴĶƘĹĻŁĽĿʼNŃN̈ŇÑŅŊÓÒÔÖǑŎŌÕŐỌØǾƠŒĥḥħıíìiîïǐĭīĩįịĳĵķƙĸĺļłľŀŉńn̈ňñņŋóòôöǒŏōõőọøǿơœŔŘŖŚŜŠŞȘṢẞŤŢṬŦÞÚÙÛÜǓŬŪŨŰŮŲỤƯẂẀŴẄǷÝỲŶŸȲỸƳŹŻŽẒŕřŗſśŝšşșṣßťţṭŧþúùûüǔŭūũűůųụưẃẁŵẅƿýỳŷÿȳỹƴźżžẓ]+$/g,
  },
  newSummaryEdit: true,
  maxBankCheckAttempts: 3, // Maximum attempts allowed to the user to go through the bank login flow, if max attempts is reached the flow will trigger an error
  addressProof: {
    enabled: false,
  },
  katakanaSupportEnabled: false,
  skipIdentityCheck: false, // adds a `skip` query param to the identity check request, if true, the check will be skipped and the API will return `result` as "invalid", along with returning the data that was originally sent.
  customFieldsRules: {
    // list of custom rules for input fields by countries
    isleofman: {
      streetName: { minLength: 2, maxLength: 42 },
    },
    ALL: {
      streetName: { minLength: 6, maxLength: 42 },
      houseNumber: { minLength: 1, maxLength: 6 },
    },
    GB: {
      password: { minLength: 8, maxLength: 16 },
      firstName: { minLength: 2, maxLength: 24 },
      lastName: { minLength: 2, maxLength: 24 },
      city: { minLength: 2, maxLength: 23 },
    },
    DE: {
      password: { minLength: 8, maxLength: 16 },
    },
  },
  germanRegulations: {
    documentUpload: {
      enabled: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/partners/config/settings.js